<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <b-nav-item v-if="menu.subMenus === undefined || menu.subMenus.length === 0" :active="menu.url == currentRouteName" class="item-nav-n2"
                @click="submenu()"
    >
      {{ menu.nombreMenu }}
    </b-nav-item>
    <b-nav-item-dropdown :key="menu.idMenu" v-else :class="'item-nav-n2 dropdown-submenu '+ (dropDownItem ? ' dropdown-submenu-2' : '')">
      <template slot="button-content">
        {{ menu.nombreMenu }}
      </template>
      <menu2 :menu="subMenu" v-for="subMenu in menu.subMenus" class="w-100"
             :key="subMenu.idMenu" :dropDownItem="true"></menu2>
    </b-nav-item-dropdown>
  </div>

</template>

<script>
import menu2 from "../navbarV2/menu2"
export default {
  name: "menu2",
  components: {
    menu2
  },
  data() {
    return {
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,
      localMenu: null
    }
  },
  props: {
    menu: Object,
    idMenuPadre: Number,
    dropDownItem: Boolean,
    visible: Boolean
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
    this.localMenu = localStorage.menuHijo
  },
  mounted() {
    this.localMenu = localStorage.menuHijo
  },
    computed: {
        currentRouteName() {
            return this.$route.name;
        }
    },
  methods: {
    getSvg(url) {
      try {
        return require('../../../assets/menu/' + url + '.svg')
      } catch (error) {
        return require('../../../assets/menu/0.svg')
      }
    },
    submenu() {
      this.$router.push({name :this.menu.url});
    },
    activo() {
      return parseInt(this.localMenu) === parseInt(this.menu.idMenu)
    }
  }
};

</script>

<style>


</style>